import { type ComponentProps } from 'react'

import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type RecType } from '@/defs/rec'
import { getRecName } from '@/utils/recUtil'

import { StatCommonBox } from '../../StatCommon/StatCommonBox/StatCommonBox'
import { StatCommonFigure } from '../../StatCommon/StatCommonFigure/StatCommonFigure'
import { StatCommonIconChevron } from '../../StatCommon/StatCommonIconChevron/StatCommonIconChevron'

type Props = {
  isInView?: boolean
  rec: RecType
  variant: 'add' | 'cut'
}

export const StatRecScore = ({ isInView, rec, variant }: Props) => {
  const { score } = rec
  const isAdd = variant === 'add'
  const label = isAdd ? 'Add Score' : 'Cut Score'

  if (score === undefined) return <StatCommonBox label={label} />

  let chevron: ComponentProps<typeof StatCommonIconChevron>['variant'] = 'neutral'
  if (score >= 75) chevron = isAdd ? 'veryHigh' : 'veryLow'
  else if (score >= 50) chevron = isAdd ? 'high' : 'low'
  else if (score >= 25) chevron = isAdd ? 'slightlyHigh' : 'slightlyLow'

  const popover = (
    <>
      <h2>
        <IconWithLabel iconBefore={isAdd ? 'plus' : 'scissors'} iconBeforeMargin='sm' iconBeforeSize='sm'>
          {label}
        </IconWithLabel>
      </h2>
      <p>
        <span>
          <strong>{label}</strong> runs from 0 to 100 and measures how strongly we recommend you{' '}
        </span>
        <span>{isAdd ? 'add' : 'cut'}</span>
        <span>
          {' '}
          <strong>{getRecName(rec)}</strong>. The range shifts with the decklist you submit.
        </span>
      </p>
    </>
  )

  return (
    <StatCommonBox isInView={isInView} label={label} popover={popover}>
      <StatCommonFigure icon={<StatCommonIconChevron variant={chevron} />} value={String(score)}>
        {score}
      </StatCommonFigure>
    </StatCommonBox>
  )
}
